// handle user & access token from APPDATA
if(window.APPDATA.user) { localStorage.setItem('user', JSON.stringify(window.APPDATA.user)); }
if(window.APPDATA.access_token) { localStorage.setItem('access_token', JSON.stringify(window.APPDATA.access_token)); }

// handle access token from localstorage
let user = JSON.parse(localStorage.getItem('user'));
let access_token = JSON.parse(localStorage.getItem('access_token'));

if(access_token) {
    let now = new Date();
    let exp = new Date(access_token.expires_at);

    if(now >= exp) {
        localStorage.removeItem('user');
        localStorage.removeItem('access_token');

        user = null;
        access_token = null;
    }
} else {
    user = null;
    access_token = null;
}

const state = {
    access_token : access_token,
    user : user,
    user_email_from_register : null,
};

const mutations = {
    USER_SET(state, data) {
        if(data && data.access_token) {
            state.user = data.user;
            state.access_token = {
                token : data.access_token,
                expires_in : data.expires_in,
                expires_at : data.expires_at,
            };

            localStorage.setItem('user', JSON.stringify(state.user));
            localStorage.setItem('access_token', JSON.stringify(state.access_token));
        } else {
            state.user = null;
            state.access_token = null;

            localStorage.removeItem('user');
            localStorage.removeItem('access_token');
        }
    },
    USER_UPDATE(state, data) {
        state.user = data.user;
        localStorage.setItem('user', JSON.stringify(state.user));
    },
    USER_EMAIL_FROM_REGISTER_SET(state, email) {
        state.user_email_from_register = email;
    },
};

const actions = {
    login({ commit, state }, params) {
        return this._vm.$http.post(this.getters.urls.api.account.login, params).then((response) => {

            if(response.data.status) {
                commit('USER_SET', response.data.data);
            }

            return response; //to epistrefo gia na peksi to then sto dispatch
        });
    },

    logout({ commit, state }, params) {
        return this._vm.$http.post(this.getters.urls.api.account.logout, params).then((response) => {

            if(response.data.status) {
                commit('USER_SET', null);
            }

            return response; //to epistrefo gia na peksi to then sto dispatch
        });
    },

    logoutSilent({ commit, state }, params) {
        return new Promise((resolve, reject) => {
            commit('USER_SET', null);

            resolve();
        });
    },

    refresh({ commit, state }, params) {
        return this._vm.$http.post(this.getters.urls.api.account.refresh, params).then((response) => {

            if(response.data.status) {
                commit('USER_SET', response.data.data);
            }

            return response; //to epistrefo gia na peksi to then sto dispatch
        });
    },

    register({ commit, state }, params) {

        return this._vm.$http.post(this.getters.urls.api.account.register, params).then((response) => {

            if(response.data.status) {
                // commit('USER_SET', response.data.data);
                commit('USER_EMAIL_FROM_REGISTER_SET', _.get(response.data.data, 'user.email'));
            }

            return response; //to epistrefo gia na peksi to then sto dispatch
        });
    },

    edit({ commit, state }, params) {

        return this._vm.$http.post(this.getters.urls.api.account.edit, params).then((response) => {

            if(response.data.status) {
                commit('USER_UPDATE', response.data.data);
            }

            return response; //to epistrefo gia na peksi to then sto dispatch
        });
    },

    delete({ commit, state }, params) {

        return this._vm.$http.post(this.getters.urls.api.account.delete, params).then((response) => {

            if(response.data.status) {
                commit('USER_SET', null);
            }

            return response; //to epistrefo gia na peksi to then sto dispatch
        });
    },

};

const getters = {
    accessToken() { return _.get(state.access_token, 'token', null); },
    user(state) { return state.user; },
    isLoggedIn(state, getters) {
        let token = _.get(state.access_token, 'token');
        let expires_at = _.get(state.access_token, 'expires_at');

        if(expires_at && token) {
            let now = new Date();
            let exp = new Date(expires_at);

            if(exp > now) {
                return true;
            }
        }

        return false;
    },
    userEmailFromRegister(state) { return state.user_email_from_register; },
    userFirstLetters(state) {
        let txt = '';

        if(_.isEmpty(_.get(state, 'user'))) { return null; }

        if(!_.isEmpty(state.user.first_name)) { txt  = state.user.first_name.charAt(0); }
        if(!_.isEmpty(state.user.last_name)) { txt  += state.user.last_name.charAt(0); }
        if(!_.isEmpty(txt)) { return txt; }


        return null;
    },
}

export default {
    state,
    actions,
    mutations,
    getters,
}
